import {makeObservable, observable} from "mobx";

import {BaseModel} from "../../../infrastructure/models/base-model";
import {singleton} from "../../../infrastructure/decorators/singleton";
import {SportDomainModel} from "../../../domain/sports/models/sport-domain-model";
import {PartialGameDomainModel} from "../../../domain/partial-game/models/partial-game-domain-model";
import {action} from "mobx"

@singleton
export class AppModuleContext extends BaseModel {
  @observable sportType: SportDomainModel;
  @observable game: PartialGameDomainModel;
  @observable tabIndex: Number;

  constructor() {
    super();

    makeObservable(this);
  }

  callbacks: Array<Function> = [];

  @action setSelectedSport(selectedSport: SportDomainModel) {
    this.sportType = selectedSport;

    this.callbacks.forEach(callbackObject => callbackObject.callback());
  }

  @action setSelectedGame(game: PartialGameDomainModel) {
    this.game = game;

    this.callbacks.forEach(callbackObject => callbackObject.callback());
  }

  @action setSelectedTabIndex(tabIndex: Number) {
    this.tabIndex = tabIndex;

    this.callbacks.forEach(callbackObject => callbackObject.callback());
  }

  registerToContextChange(id, callback) {
    this.callbacks.push({id, callback});
  }

  removeCallback(id) {
    this.callbacks = this.callbacks.filter(callbackObject => callbackObject.id !== id);
  }
}
